import { Locale } from '../intl'

const container = <T>() => {
  let x: T
  return { value: () => x, set: (v: T) => (x = v) }
}

export const localeContainer = container<Locale>()
export const screenContainer = container<string>()
